import { POLetterFrom } from '@app/shared/utils';
import { createAction, props } from '@ngrx/store';

/**
 * Show print popin
 */
export const shareAllowanceRecommendation = createAction('[Allowance] Share recommendation', props<{ value: POLetterFrom }>());
